import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import classNames from 'classnames';
import edapWrapper from '@homeaway/edap-wrapper';
import {Divider} from '@homeaway/react-collapse';
import determineIfMobile from '../HydratableDetermineIfMobile/HydratableDetermineIfMobile';
import Category from '../CollapsibleLinkpileCategory/CollapsibleLinkpileCategory';
import {
    EDAP_GENERIC_EVENT,
    EDAP_PAGE_MODULE_VIEW,
    EDAP_COLLAPSIBLE_LINKPILE_ACTION_LOCATION,
    EDAP_CONTENT_MODULE_PRESENTED,
    EDAP_CONTENT_INTERACTION_SELECTED,
    EDAP_EVENT_POSITION_FIRED_TOP,
    EDAP_EVENT_POSITION_FIRED_BOTTOM,
    EDAP_INTERACTION_CLICK,
    EDAP_EXPAND,
    EDAP_COLLAPSE
} from '../../constants';

import './CollapsibleLinkpile.less';

const getHeading = (title) => () => <h2 className="CollapsibleLinkpile__title">{title}</h2>;

export class CollapsibleLinkpile extends PureComponent {
    contentModulePresentedEventFired = {
        [EDAP_EVENT_POSITION_FIRED_TOP]: false,
        [EDAP_EVENT_POSITION_FIRED_BOTTOM]: false
    };

    getId = () => {
        const {id, title} = this.props;
        return id || `CollapsibleLinkpile_${title ? title.replace(/\W/g, '') : ''}`;
    }

    fireContentModulePresentedEvent = (position) => (isVisible) => {
        const {actionlocation} = this.props;
        const edapWrapperInstance = edapWrapper();

        if (isVisible && !this.contentModulePresentedEventFired[position]) {
            if (position === EDAP_EVENT_POSITION_FIRED_BOTTOM) {
                edapWrapperInstance.push({
                    name: EDAP_PAGE_MODULE_VIEW,
                    data: {
                        actionlocation,
                    }
                });
            }
            edapWrapperInstance.push({
                name: EDAP_CONTENT_MODULE_PRESENTED,
                data: {
                    action_location: actionlocation,
                    position_fired: position
                }
            });
            this.contentModulePresentedEventFired[position] = true;
        }
    }

    handleExpansionToggle = (isExpanded) => {
        const {actionlocation} = this.props;
        const edapWrapperInstance = edapWrapper();
        const eventaction = isExpanded ? EDAP_EXPAND : EDAP_COLLAPSE;

        edapWrapperInstance.push({
            name: EDAP_GENERIC_EVENT,
            data: {
                actionlocation,
                eventcategory: EDAP_INTERACTION_CLICK,
                eventaction
            }
        });
        edapWrapperInstance.push({
            name: EDAP_CONTENT_INTERACTION_SELECTED,
            data: {
                action_location: actionlocation,
                event_category: EDAP_INTERACTION_CLICK,
                event_action: eventaction
            }
        });
    }

    render() {
        const {title, forceExpanded, isMobile, categories, actionlocation, site} = this.props;
        return (
            !!categories.length &&
                <React.Fragment>
                    <VisibilitySensor delayedCall onChange={this.fireContentModulePresentedEvent(EDAP_EVENT_POSITION_FIRED_TOP)}>
                        <div style={{minHeight: '1px', marginTop: '-1px'}} />
                    </VisibilitySensor>
                    <div className={classNames('CollapsibleLinkpile', site)}>
                        <div className="CollapsibleLinkpile__container">
                            <Divider
                                heading={getHeading(title)}
                                expanded={forceExpanded || !isMobile}
                                id={this.getId()}
                                onExpandedChange={this.handleExpansionToggle}
                            >
                                {categories.map((category, index) => (
                                    <Category actionlocation={actionlocation} {...category} key={index} />
                                ))}
                            </Divider>
                        </div>
                    </div>
                    <VisibilitySensor delayedCall onChange={this.fireContentModulePresentedEvent(EDAP_EVENT_POSITION_FIRED_BOTTOM)}>
                        <div style={{minHeight: '1px', marginTop: '-1px'}} />
                    </VisibilitySensor>
                </React.Fragment>
        );
    }
}

CollapsibleLinkpile.propTypes = {
    actionlocation: PropTypes.string,
    forceExpanded: PropTypes.bool,
    isMobile: PropTypes.bool,
    isVisible: PropTypes.bool,
    categories: PropTypes
        .arrayOf(PropTypes.shape(Category.propTypes))
        .isRequired,
    title: PropTypes.string,
    /** An ID unique in the page. If none is provided, one based on the title will be used.  */
    id: PropTypes.string,
    site: PropTypes.string
};

CollapsibleLinkpile.defaultProps = {
    actionlocation: EDAP_COLLAPSIBLE_LINKPILE_ACTION_LOCATION,
    forceExpanded: false,
    isMobile: false,
    isVisible: false,
    title: 'More Popular Vacation Destinations',
    site: 'homeaway_us'
};

export default determineIfMobile(CollapsibleLinkpile);
